// extracted by mini-css-extract-plugin
export default {"container":"ReservationPaymentScreen_container__f8IKq","message":"ReservationPaymentScreen_message__J+NyL"};